import styled from "styled-components";

export const Header = styled.div`
  width: 100%;
  text-align: left;
`;

export const GroupedTickets = styled.div`
  text-align: left;
`;

export const RaffleLine = styled.div`
  display: flex;
  align-items: center;
  height: 52px;

  .wide {
    flex-grow: 1;
  }

  .number {
    display: flex;

    img {
      margin-right: 8px;
      width: 24px;
    }
  }

  .win-amount {
    display: flex;
    height: 24px;
    min-width: 24px;
    padding: var(--spacing-space-4, 4px) var(--spacing-space-8, 8px);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-space-4, 4px);

    border-radius: var(--rounding-radius-m, 16px);
    background: var(--fill-accent-secondary, rgba(50, 250, 220, 0.16));
    backdrop-filter: blur(12px);

    color: var(--text-primary, #000);

    /* label-s */
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 10px; /* 83.333% */
    letter-spacing: 0.5px;
  }
`;
